import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

class UxLoadingIndicatorComponent {
    constructor() {
        this._hidden = true;
        this.e2eAttr = 'ux-loading-indicator';
    }
    get hidden() { return this._hidden; }
    set hidden(value) { this._hidden = coerceBooleanProperty(value); }
    show() {
        this.hidden = false;
    }
    hide() {
        this.hidden = true;
    }
    isShown() {
        return !this.hidden;
    }
    isHidden() {
        return this.hidden;
    }
}
/** @nocollapse */ UxLoadingIndicatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxLoadingIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxLoadingIndicatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxLoadingIndicatorComponent, selector: "ux-loading-indicator", inputs: { hidden: "hidden", e2eAttr: "e2eAttr" }, ngImport: i0, template: "<div class=\"ux-loading-indicator\" [hidden]=\"hidden\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div></div>\n    <div></div>\n    <div></div>\n</div>\n", styles: [".ux-loading-indicator{display:inline-block;vertical-align:middle}.ux-loading-indicator>div{animation:ux-loading-indicator-bouncedelay 1s infinite ease-in-out both;background-color:var(--eui-base-color-black);border-radius:100%;display:inline-block;height:.5rem;margin:.25rem;width:.5rem}.ux-loading-indicator>div:nth-child(1){animation-delay:-.4s}.ux-loading-indicator>div:nth-child(2){animation-delay:-.2s}@keyframes ux-loading-indicator-bouncedelay{0%,80%,to{opacity:0;transform:scale(0) rotate(.02deg)}40%{opacity:1;transform:scale(1) rotate(.02deg)}}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxLoadingIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-loading-indicator', encapsulation: ViewEncapsulation.None, template: "<div class=\"ux-loading-indicator\" [hidden]=\"hidden\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div></div>\n    <div></div>\n    <div></div>\n</div>\n", styles: [".ux-loading-indicator{display:inline-block;vertical-align:middle}.ux-loading-indicator>div{animation:ux-loading-indicator-bouncedelay 1s infinite ease-in-out both;background-color:var(--eui-base-color-black);border-radius:100%;display:inline-block;height:.5rem;margin:.25rem;width:.5rem}.ux-loading-indicator>div:nth-child(1){animation-delay:-.4s}.ux-loading-indicator>div:nth-child(2){animation-delay:-.2s}@keyframes ux-loading-indicator-bouncedelay{0%,80%,to{opacity:0;transform:scale(0) rotate(.02deg)}40%{opacity:1;transform:scale(1) rotate(.02deg)}}\n"] }]
        }], propDecorators: { hidden: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }] } });
class UxLoadingIndicatorComponentModule {
}
/** @nocollapse */ UxLoadingIndicatorComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxLoadingIndicatorComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxLoadingIndicatorComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxLoadingIndicatorComponentModule, declarations: [UxLoadingIndicatorComponent], imports: [CommonModule], exports: [UxLoadingIndicatorComponent] });
/** @nocollapse */ UxLoadingIndicatorComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxLoadingIndicatorComponentModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxLoadingIndicatorComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxLoadingIndicatorComponent],
                    declarations: [UxLoadingIndicatorComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxLoadingIndicatorComponent, UxLoadingIndicatorComponentModule };
